import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Pagination from "@mui/material/Pagination";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import CategoryData from "../../components/datatables/categories/CategoryData";
import { getCategories } from "../../feature/category/categorySlice";

const Categories = () => {
  const dispatch = useDispatch();
  const { response, isLoading } = useSelector((state) => state.categories);

  useEffect(() => {
    window.scrollTo({ top: "0", behavior: "smooth" });
    dispatch(getCategories());
  }, [dispatch]);
  return (
    <Box component={Paper} minWidth={100} elevation={0}>
      <Box px={3} py={2}>
        <Typography variant='h4'>Categories</Typography>
      </Box>
      <Divider />
      <Box px={3} my={3}>
        <CategoryData />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          m: 5,
        }}
      >
        {/* <Pagination
          count={10}
          variant='outlined'
          showFirstButton
          showLastButton
          shape='rounded'
        /> */}
      </Box>
    </Box>
  );
};

export default Categories;
